export const ARTICLES = [
  {
    id: 'batterie-iphone-saint-chamond',
    title: "Pourquoi changer sa batterie d'iPhone à Saint-Chamond plutôt que de racheter un téléphone ?",
    excerpt: "Découvrez pourquoi remplacer la batterie de votre iPhone est plus économique et écologique que d'acheter un nouveau téléphone.",
    date: '10 avril 2026',
    dateIso: '2026-04-10',
    readTime: '3 min',
    image: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?w=800&q=80',
  },
  {
    id: 'samsung-ecran-noir-que-faire',
    title: 'Samsung Galaxy écran noir : que faire ? Solutions et réparation à Saint-Chamond',
    excerpt: "Votre Samsung s'allume mais l'écran reste noir ? Les 5 gestes à tester chez vous avant de passer chez le réparateur, et quand l'écran AMOLED doit être remplacé.",
    date: '20 juin 2026',
    dateIso: '2026-06-20',
    readTime: '5 min',
    image: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=800&q=80',
  },
  {
    id: 'proteger-ecran-iphone-conseils',
    title: "Comment protéger l'écran de son iPhone : conseils d'un réparateur de Saint-Étienne",
    excerpt: "Verre trempé, coque, gestes du quotidien : les conseils concrets d'un réparateur de la région de Saint-Étienne pour éviter l'écran cassé.",
    date: '20 juin 2026',
    dateIso: '2026-06-20',
    readTime: '4 min',
    image: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=800&q=80',
  },
  {
    id: 'batterie-telephone-qui-gonfle',
    title: 'Batterie de téléphone qui gonfle : danger, que faire, réparation à Saint-Chamond',
    excerpt: "Écran qui se soulève, dos bombé ? Une batterie gonflée est un vrai risque. Ce qu'il faut faire (et ne pas faire) immédiatement, et comment la remplacer en toute sécurité.",
    date: '20 juin 2026',
    dateIso: '2026-06-20',
    readTime: '4 min',
    image: 'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=800&q=80',
  },
];

export const getArticle = (id) => ARTICLES.find((a) => a.id === id);
